var modal = document.getElementById("myModal");
var img = document.getElementById("myImg");
var ufooter = document.querySelector(".uappfooter");

img.onclick = function(event) {
  event.preventDefault();
  modal.classList.add("upopupimg");
  ufooter.style.display = "none";
}

var closes = document.querySelectorAll('.close');

closes.forEach(function(close) {
  close.addEventListener('click', function(event) {
    event.preventDefault();
    modal.classList.remove("upopupimg");
    ufooter.style.display = "block";
  });
});
function initccrevSlider() {
    var swiper = new Swiper(".u-ccrs-swiper", {
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
        },
        speed: 1000,
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
            769: {
                slidesPerView: 2
            },
            0: {
                slidesPerView: 1
            }
        }
    });
}
function inituIWTSlider() {
  var swiper = new Swiper(".uiwtSlider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },    
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    speed: 1000,    
  });
}
var coll = document.getElementsByClassName("u-accordion-item-title");
  var i;
  for (i = 0; i < coll.length; i++) {
   coll[i].addEventListener("click", function() {
   this.classList.toggle("active");
   var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}
